import styled from "styled-components";
import theme from '../../styles/theme';

const StyledInputBox = styled.input`
    outline: 0;
    border: 1.4px solid ${theme.color.black[10]};
    background: ${theme.color.white[100]};
    // border-image-source: linear-gradient(91.1deg, #fc6741 11.83%, #ed5255 88.83%) 100% / 40px;
    padding: 0px 12px;
    // margin: 6px;
    width: calc(100% - 26.8px); // padding 12 * 2 + margin 6 * 2 + border 1.4 * 2
    height: 2.5rem;
    border-radius: 8px;
    // font-size: 18px;
    // line-height 24px;
    &:-webkit-autofill {
        transition: background-color 5000s;
        background: ${theme.color.white[100]} !important;
    }
    &:-webkit-autofill:active {
        transition: background-color 5000s;
        background: ${theme.color.white[100]} !important;
    }
    &:-webkit-autofill:hover {
        transition: background-color 5000s;
        background: ${theme.color.white[100]} !important;
    }
    &:-webkit-autofill:focus {
        transition: background-color 5000s;
        background: ${theme.color.white[100]} !important;
    }
    // &:autofill {
    //     background-color: ${theme.color.white[80]};

    // }
    // &:-webkit-autofill {
    //     background-color: ${theme.color.white[80]};
    // }
`


const InputBox = (props) => {

    return (
        <StyledInputBox {...props} />
    )

}

export default InputBox;